import { useState } from "react";
import { Input } from "../ui/input";
import { Badge } from "../ui/badge";
import { ScrollArea } from "../ui/scroll-area";
import { Search, Activity, Tv, Film, PlayCircle } from "lucide-react";

export const StatsCategories = ({ categories }) => {
  const [activeTab, setActiveTab] = useState('live');
  const [searchFilter, setSearchFilter] = useState('');
  
  const liveCategories = categories?.live || [];
  const vodCategories = categories?.vod || [];
  const seriesCategories = categories?.series || [];
  
  const getActiveCategories = () => {
    let cats = [];
    if (activeTab === 'live') cats = liveCategories;
    else if (activeTab === 'vod') cats = vodCategories;
    else cats = seriesCategories;
    
    if (searchFilter) {
      cats = cats.filter(cat => 
        cat.name?.toLowerCase().includes(searchFilter.toLowerCase())
      );
    }
    
    return [...cats].sort((a, b) => (b.count || 0) - (a.count || 0));
  };
  
  const filteredCategories = getActiveCategories();
  
  if (liveCategories.length === 0 && vodCategories.length === 0 && seriesCategories.length === 0) {
    return null;
  }
  
  return (
    <div className="space-y-4">
      <h3 className="text-sm font-medium text-muted-foreground flex items-center gap-2">
        <Activity className="h-4 w-4 text-yellow-400" />
        Détail des catégories
      </h3>
      
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Rechercher une catégorie..."
          value={searchFilter}
          onChange={(e) => setSearchFilter(e.target.value)}
          className="pl-10 bg-background/50"
        />
      </div>
      
      <div className="flex rounded-lg bg-muted/30 p-1">
        <button
          onClick={() => setActiveTab('live')}
          className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors flex items-center justify-center gap-2 ${
            activeTab === 'live' 
              ? 'bg-background text-blue-400 shadow-sm' 
              : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          <Tv className="h-4 w-4" />
          Live ({liveCategories.length})
        </button>
        <button
          onClick={() => setActiveTab('vod')}
          className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors flex items-center justify-center gap-2 ${
            activeTab === 'vod' 
              ? 'bg-background text-purple-400 shadow-sm' 
              : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          <Film className="h-4 w-4" />
          VOD ({vodCategories.length})
        </button>
        <button
          onClick={() => setActiveTab('series')}
          className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors flex items-center justify-center gap-2 ${
            activeTab === 'series' 
              ? 'bg-background text-orange-400 shadow-sm' 
              : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          <PlayCircle className="h-4 w-4" />
          Séries ({seriesCategories.length})
        </button>
      </div>
      
      <div className="space-y-1">
        <div className="flex justify-between text-xs text-muted-foreground px-2 py-1">
          <span>TOUTES LES CATÉGORIES ({filteredCategories.length})</span>
          <span>Triées par nombre</span>
        </div>
        <ScrollArea className="h-[250px] rounded-md border bg-background/30">
          <div className="p-2 space-y-1">
            {filteredCategories.length > 0 ? (
              filteredCategories.map((cat, index) => (
                <div 
                  key={cat.id || index} 
                  className="flex items-center justify-between p-2 rounded-md hover:bg-muted/50 transition-colors"
                >
                  <span className="text-sm">
                    <span className="text-muted-foreground mr-2">#{index + 1}</span>
                    {cat.name || 'Sans nom'}
                  </span>
                  <Badge 
                    variant="secondary" 
                    className={`${
                      activeTab === 'live' ? 'bg-blue-500/20 text-blue-400' :
                      activeTab === 'vod' ? 'bg-purple-500/20 text-purple-400' :
                      'bg-orange-500/20 text-orange-400'
                    }`}
                  >
                    {(cat.count || 0).toLocaleString()}
                  </Badge>
                </div>
              ))
            ) : (
              <p className="text-center text-muted-foreground py-8">
                {searchFilter ? 'Aucune catégorie trouvée' : 'Aucune catégorie'}
              </p>
            )}
          </div>
        </ScrollArea>
      </div>
    </div>
  );
};
